export default __webpack_public_path__ + "static/media/access-nft.33782eb3.png";